import type { ComponentPropsWithoutRef } from 'react';

import { ContainerPageModule, ContainerModule } from '../ContainerModule';
import { ContentModule, ContentModulePageModule } from '../ContentModule';
import { ModuleType } from '../ModuleType';

type ColumnContentModule = ContainerPageModule | ContentModulePageModule;

type ColumnContentProps = {
  content: ColumnContentModule[];
};

const ColumnContent = ({ content }: ColumnContentProps) => (
  <>
    {content.map(({ key, type, ...rest }) => {
      switch (type) {
        case ModuleType.Container:
          return (
            <ContainerModule
              key={key}
              {...(rest as ComponentPropsWithoutRef<typeof ContainerModule>)}
            />
          );
        case ModuleType.ContentModule:
          return (
            <ContentModule
              key={key}
              {...(rest as ComponentPropsWithoutRef<typeof ContentModule>)}
            />
          );
        default:
          return null;
      }
    })}
  </>
);

export { ColumnContent };
export type { ColumnContentModule, ColumnContentProps };
